import { Component, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { MessageService } from "src/app/core/services/message.service";
import { AuthenticationService, UserDto } from "../../../core/services/authentication.service";
import { LayoutService } from "../../service/layout.service";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    standalone: false
})
export class SidebarComponent {
  model: any= [];

  /**
   * Calculado, NÃO getter. Como getter, o `.map()` devolvia array e objetos novos a cada
   * ciclo de change detection e o `*ngFor` — sem trackBy — destruía e recriava todo o DOM
   * do menu a cada tick, travando a página. Aqui recalcula só quando o menu ou o usuário
   * mudam, então a identidade dos objetos é estável.
   */
  visibleModel: any[] = [];
  user: UserDto | undefined;
  modalRef?: BsModalRef;

  tooltipLabel: string | null = null;
  tooltipY = 0;

  constructor(
    public layoutService: LayoutService,
    private authService: AuthenticationService,
    private messageService: MessageService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.authService.$user.subscribe((user) => {
      this.user = user;
      this.atualizarMenuVisivel();
    });

    this.model = [
      {
        label: 'Home',
        items: [
          { label: 'Início',    icon: 'Home',            routerLink: 'home' },
          { label: 'Métricas',  icon: 'LayoutDashboard', routerLink: 'dashboard' },
          { label: 'Extrato Clina', icon: 'Wallet', routerLink: 'wallet/dashboard' },
        ],
      },
      {
        label: 'Cadastros',
        items: [
          { label: 'Usuários',    icon: 'Users',       routerLink: 'registrations/users' },
          { label: 'Clínicas',    icon: 'Building2',   routerLink: 'registrations/clinics' },
          { label: 'Consultórios',icon: 'Briefcase',   routerLink: 'registrations/room' },
          { label: 'Políticas de aluguel', icon: 'ScrollText', routerLink: 'registrations/room-lease-policy' },
          { label: 'Vitrine',     icon: 'ShoppingBag', routerLink: 'registrations/showcase' },
          { label: 'Saas',        icon: 'Cloud',       routerLink: 'registrations/saas' },
        ],
      },
      {
        label: 'Vendas',
        items: [
          { label: 'Compras',    icon: 'CalendarDays',    routerLink: 'sales/purchase' },
          { label: 'Reservas',   icon: 'CalendarClock',   routerLink: 'sales/appointments' },
          { label: 'Cobranças',  icon: 'FileText',        routerLink: 'sales/charges' },
          { label: 'Aluguel Mensal', icon: 'KeyRound',    routerLink: 'sales/room-leases' },
          { label: 'Pagamentos', icon: 'CreditCard',      routerLink: 'payment' },
        ],
      },
      {
        label: 'Desconto',
        items: [
          { label: 'Cupons', icon: 'Tag', routerLink: 'coupons/list' },
        ],
      },
      {
        label: 'Financeiro',
        items: [
          { label: 'Extrato',              icon: 'FileBarChart',  routerLink: 'wallet/extrato' },
          { label: 'Transações',           icon: 'ArrowLeftRight',routerLink: 'wallet/transactions' },
          { label: 'Saques',               icon: 'DollarSign',    routerLink: 'wallet/withdraw-approvals' },
          { label: 'Saldo por Usuário',    icon: 'Landmark',      routerLink: 'wallet/withdrawable-balances' },
          { label: 'Lançamento manual',    icon: 'CalendarPlus',  routerLink: 'wallet/credit' },
          { label: 'Lançamentos futuros',  icon: 'Clock',         routerLink: 'wallet/requests' },
          { label: 'Nota Fiscal',          icon: 'Receipt',       routerLink: 'invoice' },
        ],
      },
      {
        label: 'Config. Marketplace',
        items: [
          { label: 'Facilidades', icon: 'CheckCircle', routerLink: 'marketplace-config/facilities' },
          { label: 'Comodidades', icon: 'Star',        routerLink: 'marketplace-config/amenities' },
          { label: 'Equipamentos',icon: 'Monitor',     routerLink: 'marketplace-config/equipment' },
        ],
      },
      {
        label: 'Notificações',
        items: [
          { label: 'Histórico de envios', icon: 'Inbox',         routerLink: 'notification/history' },
          { label: 'Agendamentos',        icon: 'CalendarClock', routerLink: 'notification/schedule' },
          { label: 'WhatsApp em massa',   icon: 'MessageCircle', routerLink: 'notification/mass-whatsapp' },
          { label: 'Email em massa',      icon: 'Mail',          routerLink: 'notification/mass-email' },
          { label: 'Templates de email',  icon: 'FileText',      routerLink: 'notification/templates' },
        ],
      },
      {
        label: 'Tecnologia',
        roles: ['admin', 'BKF_ADMIN', 'BKF_TEC'],
        items: [
          { label: 'Como o sistema funciona', icon: 'BookOpen', routerLink: 'system-info' },
          // Expõe saúde de provedores, contagem de filas e o feed de eventos.
          { label: 'Monitoramento',           icon: 'Activity', routerLink: 'monitoring', roles: ['admin'] },
        ],
      },
      {
        label: 'Outros',
        items: [
          { label: 'Auditoria',     icon: 'ShieldAlert', routerLink: 'audit' },
          { label: 'Sair',          icon: 'LogOut',      action: 'logout' },
        ],
      },
    ];

    // Depois de montar o menu: o BehaviorSubject do usuário emite na hora da inscrição,
    // quando `model` ainda era [], então o cálculo de lá não vale por si.
    this.atualizarMenuVisivel();
  }

  get isMini(): boolean {
    return this.layoutService.isDesktop() && this.layoutService.state.staticMenuDesktopInactive;
  }

  getInitials(name?: string): string {
    if (!name) return "";
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map((part) => part[0]?.toUpperCase() || "").join("");
  }

  onItemEnter(item: any, event: MouseEvent): void {
    if (!this.isMini) return;
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.tooltipLabel = item.label;
    this.tooltipY = rect.top + rect.height / 2;
  }

  /**
   * Grupo ou item com `roles` só aparece para quem tem um dos papéis. Enquanto o usuário
   * não resolve (`undefined` no primeiro tick do BehaviorSubject), o restrito fica oculto —
   * é o lado seguro: melhor aparecer com atraso que piscar para quem não pode ver.
   *
   * Grupo que fica sem nenhum item visível é omitido, senão sobraria só o cabeçalho.
   */
  private atualizarMenuVisivel(): void {
    const groups = this.user?.groups ?? [];
    const permitido = (entry: any): boolean => !entry?.roles?.length || entry.roles.some((role: string) => groups.includes(role));

    this.visibleModel = (this.model ?? [])
      .filter(permitido)
      .map((group: any) => ({ ...group, items: (group.items ?? []).filter(permitido) }))
      .filter((group: any) => group.items.length > 0);
  }

  onItemLeave(): void {
    this.tooltipLabel = null;
  }

  onItemClick(item: any, event: Event, template: TemplateRef<any>): void {
    if (item?.action !== "logout") return;
    event.preventDefault();
    this.openLogoutModal(template);
  }

  openLogoutModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, { class: "modal-dialog-centered" });
  }

  confirmLogout(): void {
    this.modalRef?.hide();
    this.authService.signOut().catch((error) => {
      console.error("Erro ao fazer logout:", error);
      this.messageService.add({
        severity: "error",
        summary: "Erro",
        detail: "Ocorreu um erro ao sair do sistema.",
      });
    });
  }
}
